import React from 'react'
import { Button, Grid, Typography } from '@material-ui/core'
import clsx from 'clsx'

import { useRoutes } from 'hooks'
import StandartTable from 'asterX-UIkit/Table/StandartTable'
import { REQUEST_PATH } from 'routes/constants.routes'
import { Pagination } from '@material-ui/lab'
import { useTableStyles } from './table.styles'
import { useHomeStore } from 'context/HomeStore'
import { AsterChip } from 'asterX-UIkit/Chips'
import { getNotification, tableStatusBtns } from '../const'
import { colorStatusesByCode } from 'constants/constants'
import { EmptyLists } from '../EmptyLists/EmptyLists'
import moment from 'moment/moment'

export const Table = () => {
  const classes = useTableStyles()
  const router = useRoutes()
  const {
    homeStore: { lists, wlTab, pagination },
    homeStoreFunc: {
      onPaginationChange,
      setWlTab,
      setSelectedStatus,
      getSupportList
    }
  } = useHomeStore()

  const columns = [
    'Номер заявки',
    'Раздел',
    'Статус',
    'Дата создания',
    'Ответственный',
    'Уведомление'
  ]

  const rows = lists
    ? lists?.map(item => {
        const {
          id,
          department,
          module,
          status,
          createdDate,
          adminFullname,
          unAnswered,
          hadQuestionnaire
        } = item
        const hours = createdDate
          ? moment(new Date(createdDate)).format('HH:mm')
          : '-'
        const date = createdDate
          ? moment(new Date(createdDate)).format('DD.MM.YYYY')
          : '-'
        return [
          id,
          <Grid item>
            {department === 'AsterX' && <Typography>{department}</Typography>}
            <Typography className={classes.subtitle}>{module}</Typography>
          </Grid>,
          <AsterChip
            label={status || '-'}
            style={{
              ...colorStatusesByCode(status)
            }}
          />,
          <Grid item>
            <Typography>{hours}</Typography>
            <Typography className={classes.subtitle}>{date}</Typography>
          </Grid>,
          <Grid item>
            <Typography>{adminFullname || 'Ожидаем ...'}</Typography>
            {adminFullname && (
              <Typography className={classes.subtitle}>{department}</Typography>
            )}
          </Grid>,
          <AsterChip
            label={getNotification(status, unAnswered, hadQuestionnaire).text}
            style={{
              ...getNotification(status, unAnswered, hadQuestionnaire),
              borderRadius: 6,
              padding: '2px 8px 2px 8px',
              cursor: 'pointer'
            }}
          />
        ]
      })
    : []

  const handleChangeTabs = (item, index) => {
    const status = item.code
    setWlTab(index)
    setSelectedStatus(status)
    getSupportList(status, pagination.offset, pagination.limit)
  }

  return (
    <Grid item container>
      {!lists?.length && wlTab === 0 ? (
        <EmptyLists />
      ) : (
        <>
          <Grid item container className={classes.filterTabs}>
            {tableStatusBtns.map((item, index) => {
              const isActive = wlTab === index

              return (
                <Grid key={`table_${index}`} item>
                  <Button
                    className={clsx(
                      classes.tableStatusBtn,
                      isActive ? classes.tableStatusBtnActive : ''
                    )}
                    onClick={() => handleChangeTabs(item, index)}
                  >
                    {item.label}
                  </Button>
                </Grid>
              )
            })}
          </Grid>

          <Grid item container className={classes.table}>
            <Grid item container>
              <StandartTable
                tableData={{
                  names: columns,
                  rows
                }}
                onRowClick={row => {
                  router.goTo(`${REQUEST_PATH}/${row[0]}`)
                }}
                tableStyles={{
                  borderRadius: 12,
                  boxShadow: 'none'
                }}
              />
            </Grid>
            <Grid item container style={{ padding: '12px 24px' }}>
              <Pagination
                variant="outlined"
                shape="rounded"
                size="large"
                className={classes.pagination}
                count={pagination.count}
                page={pagination.offset ? pagination.offset : 1}
                onChange={onPaginationChange}
              />
            </Grid>
          </Grid>
        </>
      )}
    </Grid>
  )
}
